export default __webpack_public_path__ + "static/media/0.3b9846c2.png";